/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Form as FinalForm, Field } from 'react-final-form';
import createDecorator from 'final-form-focus';
import cn from 'classnames';

// Components
import Form from 'components/Form';
import InputField from 'components/InputField';

// Utils
import { required } from 'utils/validators';

import styles from './styles.styl';
import SearchIcon from 'ui/icons/SearchIcon';
import CloseIcon from 'ui/icons/CloseIcon';

const focusOnError = createDecorator();

const Search = ({
  className,
  fieldClassName,
  name,
  placeholder,
  theme,
  isRequired,
  inputValue,
  defaultValue,
  onChange,
  handleSubmit,
}) => (
  <FinalForm
    initialValues={{ search: defaultValue }}
    onSubmit={handleSubmit}
    decorators={[focusOnError]}
    render={({ form, handleSubmit }) => (
      <Form
        className={cn(styles.Search, className, {
          [styles[`Search_${theme}`]]: theme,
        })}
        onSubmit={handleSubmit}
      >
        <Field name={name} validate={isRequired ? required : undefined}>
          {({ input, meta: { invalid, active, visited } }) => (
            <InputField
              {...input}
              className={cn(
                styles.Search__field,
                {
                  [styles.Search__field_active]: active || input.value,
                },
                fieldClassName,
              )}
              theme="search"
              onChange={onChange || input.onChange}
              placeholder={placeholder}
              invalid={invalid}
              active={active}
              visited={visited}
            />
          )}
        </Field>
        {defaultValue === '' ||
        (defaultValue !== form.getState().values.search && form.getState().values.search !== '') ? (
          <button type="submit" className={styles.Search__button}>
            <SearchIcon className={styles.Search__buttonIcon} />
          </button>
        ) : (
          <button
            onClick={() => {
              form.change('search', '');
            }}
            className={styles.Search__button}
          >
            <CloseIcon className={styles.Search__buttonIcon} />
          </button>
        )}
      </Form>
    )}
  />
);

Search.defaultProps = {
  className: '',
  placeholder: '',
  isRequired: true,
};

Search.propTypes = {
  className: PropTypes.string,
  fieldClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  theme: PropTypes.string,
  defaultValue: PropTypes.string,
  inputValue: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
};

export default Search;
